import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IHamburgerOverlayMapperProps,
  IHamburgerOverlayControllerProps,
  IHamburgerOverlayProps,
  IHamburgerOverlayStateValues,
} from '../HamburgerOverlay.props';

export default withCompController<
  IHamburgerOverlayMapperProps,
  IHamburgerOverlayControllerProps,
  IHamburgerOverlayProps,
  IHamburgerOverlayStateValues
>(({ mapperProps, stateValues }) => {
  const { compId } = mapperProps;

  const { setSiteScrollingBlocked } = stateValues;

  const onOpenStateChange = (isOpen: boolean) => {
    setSiteScrollingBlocked(isOpen, compId);
  };

  return {
    ...mapperProps,
    onOpenStateChange,
  };
});
